import { css } from 'styled-components'

import interactiveFocusStyle from 'styles/utils/interactiveFocusStyle'

export const cardItemHoverAnimation = css`
  transition: box-shadow 0.2s;
  box-shadow: none;

  &:focus,
  &:focus-within,
  &:hover {
    box-shadow: ${(props) => props.theme.shadow.bottom.small};
  }

  &:focus,
  &:focus-within {
    ${interactiveFocusStyle}
  }
`

// Not really sure what else to add here, comment in PR
export const buttonFakerStyles = css`
  &[role='button'] {
    [aria-disabled] {
      cursor: not-allowed;
    }
    cursor: pointer;
  }
`
